import type {
  InputParams,
  IViewArticle,
  IViewError,
  IViewFrontpage,
  IViewListing,
  IViewLockedArticle,
  IViewPage,
  IViewWeather,
} from '@schibsted/pulse-sdk';
import type { PulseContextInputParams } from '../../types/index.js';

import { createObjectSdrn } from './create-object-sdrn.js';

type ViewEvent =
  | IViewArticle
  | IViewError
  | IViewFrontpage
  | IViewListing
  | IViewPage
  | IViewLockedArticle
  | IViewWeather;

type PageType =
  | 'Article'
  | 'Error'
  | 'Frontpage'
  | 'Listing'
  | 'Page'
  | 'LockedArticle'
  | 'Weather';

export const buildViewEvent = <TEvent extends ViewEvent>({
  pageType,
  event,
  providerId,
  providerInput,
}: {
  pageType: PageType;
  event: PulseContextInputParams<TEvent>;
  providerId: string;
  providerInput: InputParams<TEvent>['provider'];
}): InputParams<TEvent> =>
  ({
    ...event,
    object: {
      ...event.object,
      objectSdrn: createObjectSdrn(providerId, pageType, event.object.objectId),
    },
    provider: providerInput,
  }) as InputParams<TEvent>;
